import {
  TableHeader,
  SearchFieldInput,
  FormSelectChoice,
  KeyStringValue,
} from "../interfaces";
import { createUrlSafePathing } from "../common/services/Utilities";

export const numericalRegEx = "^[0-9]{0,5}$";

export const rssdRegEx = "^[0-9]{0,7}$";

export const currencyRegEx = "^[-]{0,1}[0-9]{0,16}$";

export const twoDecimalPlacesRegEx = "^[-]{0,1}[0-9]{0,12}[.]{0,1}[0-9]{0,2}$";

export const websiteRegex = /(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/;

export const dateOptions = {
  year: "numeric",
  month: "long",
  day: "numeric",
};

export const historicalFormSelectChoices: FormSelectChoice[] = [
  { label: "Commercial Banks - Structure", value: "CBS", checked: false },
  { label: "Commercial Banks - Financial", value: "CBF", checked: false },
  { label: "Savings Institution - Structure", value: "SIS", checked: false },
  { label: "Savings Institution - Financial", value: "SIF", checked: false },
];

export const bankFailuresFormSelectChoices: FormSelectChoice[] = [
  { label: "Details", value: "details", checked: false },
  { label: "By State", value: "by_state", checked: false },
  { label: "By Year", value: "by_year", checked: false },
];

export const bankFindFormSelectChoices: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "cert", checked: false },
  { label: "Web Address/ URL", value: "url", checked: false },
];
export const branchOfficeSelectBanksChoices: FormSelectChoice[] = [
  { label: "FDIC Cert", value: "cert", checked: false },
  { label: "Bank Name", value: "name", checked: false },
  { label: "OTS Docket Number", value: "OTSDocket", checked: false },
  { label: "Federal Reserve ID", value: "rssdid", checked: false },
];

export const branchOfficeSelectBHSChoices: FormSelectChoice[] = [
  { label: "BHC Name", value: "bhcName", checked: false },
  { label: "BHC ID (RSSDHCR)", value: "bhcRSSD", checked: false },
];
export const marketShareLocationOptions: FormSelectChoice[] = [
  { label: "Find Office Locations By", value: "", checked: false },
  {
    label: "State / County / City / ZIP",
    value: "marketSelect",
    checked: false,
  },
  {
    label: "County Summaries by State",
    value: "countyByState",
    checked: false,
  },
  {
    label: "Metropolitan Statistical Areas (MSA)",
    value: "msa",
    checked: false,
  },
  { label: "ZIP Code Only", value: "zip", checked: false },
];
export const marketShareLocationOptions2: FormSelectChoice[] = [
  { label: "Find Office Locations By", value: "", checked: false },
  {
    label: "State / County / City / ZIP",
    value: "marketSelect",
    checked: false,
  },
  {
    label: "Metropolitan Statistical Areas (MSA)",
    value: "msa",
    checked: false,
  },
];

export const branchOfficeLocationOptions: FormSelectChoice[] = [
  { label: "Select Location Type", value: "", checked: false },
  {
    label: "State / County / City / ZIP",
    value: "marketSelect",
    checked: false,
  },
  {
    label: "Metropolitan Statistical Areas (MSA)",
    value: "msa",
    checked: false,
  },
  { label: "ZIP Code Only", value: "zip", checked: false },
];
export const proFormaLocationOptions: FormSelectChoice[] = [
  { label: "Select Location Type", value: "", checked: false },
  {
    label: "State / County / City / ZIP",
    value: "marketSelect",
    checked: false,
  },
  {
    label: "Metropolitan Statistical Areas (MSA)",
    value: "msa",
    checked: false,
  },
  { label: "ZIP Code Only", value: "zip", checked: false },
];
export const summaryTablesReportTypeOptions: FormSelectChoice[] = [
  { label: "Select Summary Type", value: "", checked: false },
  {
    label: "National - By Charter Class",
    value: "charterClass",
    header: "National Totals by Charter Class",
    checked: false,
  },
  {
    label: "National - By Asset Size",
    value: "assetSize",
    header: "National Totals by Asset Size",
    checked: false,
  },
  {
    label:
      "National - Top 50 Commercial Banks and Savings Institutions by Deposits",
    value: "top50CommercialBanks",
    header:
      "Top 50 Commercial Banks and Savings Institutions by Domestic Deposits",
    checked: false,
  },
  {
    label: "National - Top 50 Bank Holding Companies By Deposits",
    value: "top50BHC",
    header: "Top 50 Bank Holding Companies by Domestic Deposits",
    checked: false,
  },
  {
    label: "National - By States & Territories",
    value: "stateAndTerritories",
    header: "National Totals by States & Territories",
    checked: false,
  },
  {
    label: "National - Time Series of States by Year",
    value: "nationalTimeSeries",
    header: "National - Time Series of States by Year",
    checked: false,
  },
  {
    label: "MSA - Metropolitan Statistical Area",
    value: "metroStatisticalArea",
    header: "Regional Totals by MSA",
    checked: false,
  },
  {
    label: "State - Charter Class",
    value: "stateCharterClass",
    header: "Individual State Totals by Charter Class",
    checked: false,
  },
  {
    label: "State - By County",
    value: "stateCounty",
    header: "Individual State Totals by County",
    checked: false,
  },
];

export const marketShareReportTypeOptions: FormSelectChoice[] = [
  { label: "Select Report Type", value: "", checked: false },
  {
    label: "Deposit Market Share",
    value: "depositMarketShare",
    checked: false,
  },
  { label: "Pro-Forma", value: "proForma", checked: false },
  { label: "Market Presence", value: "marketPresence", checked: false },
  { label: "Growth Rate", value: "growthRate", checked: false },
];

export const marketShareReportChoicesBanks: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "cert", checked: false },
];

export const marketShareReportChoicesBHCs: FormSelectChoice[] = [
  { label: "Holding Company ID (RSSDHCR)", value: "bhcRSSD", checked: false },
  { label: "Holding Company Name", value: "bhcName", checked: false },
];

export const GrowthRateReportChoicesBanks: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "cert", checked: false },
];

export const GrowthRateReportChoicesBHCs: FormSelectChoice[] = [
  { label: "Holding Company ID (RSSDHCR)", value: "bhcRSSD", checked: false },
  { label: "Holding Company Name", value: "bhcName", checked: false },
];

export const marketDisplayResultOptions: FormSelectChoice[] = [
  {
    label: "States by County",
    value: "statesByCounty",
    checked: false,
  },
  { label: "MSAs", value: "msas", checked: false },
];
export const growthRateDisplayResultOptions: FormSelectChoice[] = [
  {
    label: "States by County",
    value: "statesByCounty",
  },
  { label: "MSAs", value: "msas", checked: false },
];

export const summaryTablesInstitutionTypeOptions: FormSelectChoice[] = [
  { label: "Select Institution Type", value: "", checked: false },
  { value: "All Institutions", label: "All Institutions", checked: false },
  { value: "Commercial Banks", label: "Commercial Banks", checked: false },
  {
    value: "Savings Institutions",
    label: "Savings Institutions",
    checked: false,
  },
  {
    value: "U.S. Branches of Foreign Banks",
    label: "U.S. Branches of Foreign Banks",
    checked: false,
  },
];

export const summaryTablesTotalsTypeOptions: FormSelectChoice[] = [
  { label: "Select Totals Type", value: "", checked: false },
  { value: "Institutions", label: "Totals by Institutions", checked: false },
  {
    value: "Branch Offices",
    label: "Totals by Branch Offices",
    checked: false,
  },
  { value: "Deposits", label: "Totals by Deposits ", checked: false },
];

export const oscrFormSelectChoices: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "certSearch", checked: false },
];

export const financialReportingFormSelectChoicesBanks: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "cert", checked: false },
];

export const customizedComparisonSelectChoices: FormSelectChoice[] = [
  { label: "Bank Name", value: "name", checked: false },
  { label: "FDIC Cert #", value: "cert", checked: false },
];

export const financialReportingFormSelectChoicesBHCs: FormSelectChoice[] = [
  { label: "BHC Name", value: "bhcName", checked: false },
  { label: "BHC RSSD ID #", value: "bhcRSSD", checked: false },
];

export const financialsSelectChoices: FormSelectChoice[] = [
  { value: "ASSET", label: "Total Assets" },
  { value: "DEP", label: "Total Deposits" },
  { value: "NETINCQ", label: "Net Income - Qtr" },
  { value: "NETINC", label: "Net Income - YTD" },
  { value: "ROAPTXQ", label: "Pre-tax Return on Assets - % Qtr" },
  { value: "ROAPTX", label: "Pre-tax Return on Assets - % YTD" },
];

export const commonSearchChoices: { [key: string]: FormSelectChoice[] } = {
  charterType: [
    { value: "INSCOML:1", label: "Insured Commercial Banks" },
    { value: "INSSAVE:1", label: "Insured Savings Institutions" },
    { value: "OI:1", label: "Insured Branches of Foreign Banks" },
  ],
  assetConcentration: [
    { value: "INSALL:1", label: "All Insured Institutions" },
    { value: "3", label: "Credit Card Banks" },
    { value: "1", label: "International Banks" },
    { value: "2", label: "Agricultural Banks" },
    { value: "4", label: "Commercial Lenders" },
    { value: "5", label: "Mortgage Lenders" },
    { value: "6", label: "Consumer Lenders" },
    { value: "7", label: "Other Specialized <$1Billion" },
    { value: "8", label: "All Other <$1Billion" },
    { value: "9", label: "All Other >$1Billion" },
  ],
  commonSearch: [
    { value: "top100", label: "Top 100 Banks and Thrifts by Assets" },
    { value: "SPECGRP:2", label: "Agricultural Banks" },
    {
      value: "OFFFOR:[1 TO *]",
      label: "Banks HQ'd in the US with Foreign Offices",
    },
    {
      value: "PARCERT:[1 TO *]",
      label: "Banks Directly Owned by Another Bank ",
    },
    { value: "CB:1", label: "FDIC Community Banks" },
    { value: "FEDCHRTR:1", label: "Federal Charter" },
    { value: "STCHRTR:1", label: "State Charter" },
    {
      value: "MUTUAL:0 AND INSSAVE:1",
      label: "Mutual (non-stock) Savings Institutions",
    },
    { value: "MINORITY:1", label: "Minority Owned Institutions" },
    {
      value: "MUTUAL:1 AND INSSAVE:1",
      label: "Stock Held Savings Institutions",
    },
    { value: "SUBCHAPS:1", label: "Subchapter S Corporation" },
    { value: "TRUST:1", label: "Trust Powers Granted" },
    { value: "TREXER:1", label: "Trust or Related Activity" },
  ],
};

export const regulatorySelectChoices: { [key: string]: FormSelectChoice[] } = {
  charterClass: [
    { value: "ALL", label: "All Insured Bank Charter Classes" },
    {
      value: "N",
      label: "National Banks, member of the Federal Reserve System (FRS)",
    },
    {
      value: "SM",
      label: "State Chartered Banks, member of the Federal Reserve System (SM)",
    },
    {
      value: "NM",
      label:
        "State Chartered Banks, not member of the Federal Reserve System (NM)",
    },
    { value: "SI", label: "FDIC Supervised State Savings Banks (SI)" },
    { value: "SL", label: "Federal & State Savings and Loans (SL)" },
    { value: "SB", label: "Federal Savings Bank (SB)" },
    { value: "OI", label: "Insured Branches of Foreign Banks (OI)" },
  ],
  charteringAgency: [
    { value: "ALL", label: "All Chartering Agencies" },
    { value: "OCC", label: "Office of the Comptroller of the Currency (OCC)" },
    { value: "OTS", label: "Office of Thrift Supervision (OTS before 2012)" },
    { value: "STATE", label: "State (includes US Territories)" },
  ],
  primaryRegulator: [
    { value: "ALL", label: "All Regulators" },
    { value: "OCC", label: "Office of the Comptroller of the Currency (OCC)" },
    { value: "FDIC", label: "Federal Deposit Insurance Corporation (FDIC)" },
    { value: "FED", label: "Federal Reserve Board (FRB)" },
    { value: "OTS", label: "Office of Thrift Supervision (OTS before 2012)" },
  ],
  regionTypeOffice: [
    {
      value: "profile",
      label: "Quarterly Banking Profile Region",
    },
    {
      value: "geographic",
      label: "FDIC Geographic Region",
    },
    {
      value: "supervisory",
      label: "FDIC Supervisory Region",
    },
    {
      value: "fieldOffices",
      label: "FDIC Field Offices",
    },
    {
      value: "msa",
      label: "Metropolitan Statistical Areas (MSA)",
    },
  ],
};

export const defaultRegulatoryRegionType: any = {
  "": [
    {
      value: "",
      label: "Make Selection Above",
    },
  ],
  "profile": [
    { value: "", label: "Select Quarterly Banking Profile Region" },
    {
      value: "1",
      label: "All Regions",
    },
    {
      value: "02",
      label: "Atlanta Region",
    },
    {
      value: "03",
      label: "Chicago Region",
    },
    {
      value: "05",
      label: "Dallas Region",
    },
    {
      value: "04",
      label: "Kansas City Region",
    },
    {
      value: "01",
      label: "New York Region",
    },
    {
      value: "06",
      label: "San Francisco Region",
    },
  ],

  "geographic": [
    { value: "", label: "Select FDIC Geographic Region" },
    {
      value: "1",
      label: "All Regions",
    },
    {
      value: "05",
      label: "Atlanta Region",
    },
    {
      value: "09",
      label: "Chicago Region",
    },
    {
      value: "13",
      label: "Dallas Region",
    },
    {
      value: "11",
      label: "Kansas City Region",
    },
    {
      value: "02",
      label: "New York Region",
    },
    {
      value: "14",
      label: "San Francisco Region",
    },
  ],

  "supervisory": [
    { value: "", label: "Select FDIC Supervisory Region" },
    {
      value: "1",
      label: "All Regions",
    },
    {
      value: "05",
      label: "Atlanta Region",
    },
    {
      value: "09",
      label: "Chicago Region",
    },
    {
      value: "13",
      label: "Dallas Region",
    },
    {
      value: "11",
      label: "Kansas City Region",
    },
    {
      value: "02",
      label: "New York Region",
    },
    {
      value: "14",
      label: "San Francisco Region",
    },
    {
      value: "16",
      label: "Washington Office - CFI",
    },
    {
      value: "15",
      label: "Washington Office - RMS",
    },
  ],

  "fieldOffices": [
    { value: "", label: "Select FDIC Field Offices" },
    { value: "1", label: "All Field Offices" },
  ],

  "msa": [
    { value: "", label: "Select MSA" },
  ],
};

export const defaultSearchFieldInputLookup: SearchFieldInput = {
  "": {
    placeholder: "Make Selection Above",
    label: "Make Selection Above",
    regEx: undefined,
  },
  "name": {
    placeholder: "Enter Bank Name",
    label: "Bank Name",
    regEx: undefined,
    autoComplete: true,
  },
  "cert": {
    placeholder: "Enter FDIC Cert",
    label: "FDIC Cert",
    regEx: numericalRegEx,
  },
  "bhcName": {
    placeholder: "Enter BHC Name",
    label: "BHC Name",
    regEx: undefined,
    autoComplete: true,
  },
  "bhcRSSD": {
    placeholder: "Enter BHC RSSD ID #",
    label: "Bank Holding Company ID",
    regEx: rssdRegEx,
  },
  "certSearch": {
    placeholder: "Enter FDIC Cert",
    label: "FDIC Cert",
    regEx: numericalRegEx,
  },
  "url": {
    placeholder: "Enter Web Address",
    label: "Enter Web Address",
    regEx: undefined,
  },
  "rssdid": {
    placeholder: "Enter Federal Reserve ID",
    label: "Federal Reserve ID",
    regEx: rssdRegEx,
  },
  "OTSDocket": {
    placeholder: "Enter OTS Docket Number",
    label: "OTS Docket Number",
    regEx: numericalRegEx,
  },
};
export const sodSearchFieldInputLookup: SearchFieldInput = {
  "": {
    placeholder: "Make Selection Above",
    label: "Make Selection Above",
    regEx: undefined,
  },
  "name": {
    placeholder: "Enter Bank Name",
    label: "Bank Name",
    regEx: undefined,
    autoComplete: true,
    apiPath: "sod",
    uniqueField: "NAMEFULL",
  },
  "cert": {
    placeholder: "Enter FDIC Cert",
    label: "FDIC Cert",
    regEx: numericalRegEx,
  },
  "bhcName": {
    placeholder: "Enter BHC Name",
    label: "BHC Name",
    regEx: undefined,
    autoComplete: true,
    apiPath: "sod",
    uniqueField: "NAMEHCR",
  },
  "bhcRSSD": {
    placeholder: "Enter BHC RSSDHCR #",
    label: "Bank Holding Company ID",
    regEx: rssdRegEx,
  },
  "rssdid": {
    placeholder: "Enter Federal Reserve ID",
    label: "Federal Reserve ID",
    regEx: rssdRegEx,
  },
  "OTSDocket": {
    placeholder: "Enter OTS Docket Number",
    label: "OTS Docket Number",
    regEx: numericalRegEx,
  },
};

export const NEW_INSTITUTIONS = "New Institutions";
export const BUSINESS_COMBINATIONS = "Business Combinations";
export const BUSINESS_COMBINATIONS_FAILURES =
  "Business Combinations - Failures";
export const INTERIM_MERGERS = "Interim Mergers & Reorganizations";
export const CONVERSIONS = "Conversions";
export const TITLE_CHANGES = "Title Changes";
export const MAIN_OFFICE_RELOCATIONS = "Main Office Relocations";
export const LIQUIDATIONS = "Liquidations";
export const TRUST_POWERS = "Trust Powers";
export const BRANCH_OFFICE_RELOCATIONS = "Branch Office Relocations";
export const PANDAS = "Branch Purchases & Assumptions by Institution";
export const OFFICE_OPENINGS = "Branch Office Openings";
export const OFFICE_CLOSINGS = "Branch Office Closings";

export const structureChangeLevelTwoPathingMap = {
  [createUrlSafePathing(NEW_INSTITUTIONS)]: NEW_INSTITUTIONS,
  [createUrlSafePathing(BUSINESS_COMBINATIONS)]: BUSINESS_COMBINATIONS,
  [createUrlSafePathing(
    BUSINESS_COMBINATIONS_FAILURES,
  )]: BUSINESS_COMBINATIONS_FAILURES,
  [createUrlSafePathing(INTERIM_MERGERS)]: INTERIM_MERGERS,
  [createUrlSafePathing(CONVERSIONS)]: CONVERSIONS,
  [createUrlSafePathing(TITLE_CHANGES)]: TITLE_CHANGES,
  [createUrlSafePathing(MAIN_OFFICE_RELOCATIONS)]: MAIN_OFFICE_RELOCATIONS,
  [createUrlSafePathing(LIQUIDATIONS)]: LIQUIDATIONS,
  [createUrlSafePathing(TRUST_POWERS)]: TRUST_POWERS,
  [createUrlSafePathing(PANDAS)]: PANDAS,
  [createUrlSafePathing(BRANCH_OFFICE_RELOCATIONS)]: BRANCH_OFFICE_RELOCATIONS,
  [createUrlSafePathing(OFFICE_OPENINGS)]: OFFICE_OPENINGS,
  [createUrlSafePathing(OFFICE_CLOSINGS)]: OFFICE_CLOSINGS,
};

export const oscrReportTypesDictionary: {
  [key: string]: number[];
} = {
  [NEW_INSTITUTIONS]: [1, 110],
  [BUSINESS_COMBINATIONS]: [221, 222, 223, 224, 225],
  [BUSINESS_COMBINATIONS_FAILURES]: [211, 213, 215, 216, 217],
  [INTERIM_MERGERS]: [820, 830, 350, 360],
  [CONVERSIONS]: [150, 310, 320, 410, 411, 420, 430, 440, 470],
  [TITLE_CHANGES]: [510],
  [MAIN_OFFICE_RELOCATIONS]: [520],
  [LIQUIDATIONS]: [230, 235, 240, 260],
  [TRUST_POWERS]: [610],
  [PANDAS]: [712],
  [BRANCH_OFFICE_RELOCATIONS]: [520999],
  [OFFICE_OPENINGS]: [711],
  [OFFICE_CLOSINGS]: [721],
};

export const oscrReportTypeChangeCodes = {
  Institutions: [].concat(
    ...[
      NEW_INSTITUTIONS,
      BUSINESS_COMBINATIONS,
      BUSINESS_COMBINATIONS_FAILURES,
      INTERIM_MERGERS,
      CONVERSIONS,
      TITLE_CHANGES,
      MAIN_OFFICE_RELOCATIONS,
      LIQUIDATIONS,
      TRUST_POWERS,
      PANDAS,
    ].map(key => oscrReportTypesDictionary[key] as never[]),
  ),
  Offices: [].concat(
    ...[BRANCH_OFFICE_RELOCATIONS, OFFICE_OPENINGS, OFFICE_CLOSINGS].map(
      key => oscrReportTypesDictionary[key] as never[],
    ),
  ),
};
export const bfReportTypesDictionary: {
  [key: string]: number[];
} = {
  [NEW_INSTITUTIONS]: [1, 110],
  [BUSINESS_COMBINATIONS]: [221, 222, 223, 224, 225, 810, 811, 812],
  [BUSINESS_COMBINATIONS_FAILURES]: [211, 213, 215, 216, 217],
  [INTERIM_MERGERS]: [820, 830, 350, 360],
  [CONVERSIONS]: [150, 310, 320, 410, 411, 420, 430, 440, 470],
  [TITLE_CHANGES]: [510],
  [MAIN_OFFICE_RELOCATIONS]: [520],
  [LIQUIDATIONS]: [230, 235, 240, 260],
  [TRUST_POWERS]: [610],
  [PANDAS]: [712],
  [BRANCH_OFFICE_RELOCATIONS]: [520999],
  [OFFICE_OPENINGS]: [711],
  [OFFICE_CLOSINGS]: [721],
};

export const DEFAULT_ADDRESS = "DEFAULT_ADDRESS";
export const PHYSICAL_ADDRESS = "PHYSICAL_ADDRESS";
export const FORMATTED_DATE = "FORMATTED_DATE";
export const VIEW_DETAILS = "VIEW_DETAILS";
export const OFFICE_ADDRESS = "OFFICE_ADDRESS";
export const FROM_ADDRESS = "FROM_ADDRESS";
export const FROM_OFFICE_ADDRESS = "FROM_OFFICE_ADDRESS";
export const MAILING_ADDRESS = "MAILING_ADDRESS";
export const SUR_ADDRESS = "SUR_ADDRESS";
export const SUR_MAILING_ADDRESS = "SUR_MAILING_ADDRESS";
export const FRM_PADDR = "FRM_PADDR";
export const ACQ_ADDRESS = "ACQ_ADDRESS";
export const ACQ_MAILING_ADDRESS = "ACQ_MAILING_ADDRESS";
export const OUT_ADDRESS = "OUT_ADDRESS";
export const OFF_SERVTYPE_DESC = "OFF_SERVTYPE_DESC";
export const CHANGECODE_DESC = "CHANGECODE_DESC";
export const SUR_CHANGECODE_DESC = "SUR_CHANGECODE_DESC";
export const BRANCH_ADDRESS = "BRANCH_ADDRESS";

export const levelTwoOrderedKeysLookup: { [key: string]: string[] } = {
  [NEW_INSTITUTIONS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    "REGAGENT",
    PHYSICAL_ADDRESS,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [BUSINESS_COMBINATIONS]: [
    "OUT_INSTNAME",
    "OUT_CERT",
    "ACQ_INSTNAME",
    "ACQ_CERT",
    "SUR_INSTNAME",
    "SUR_CERT",
    CHANGECODE_DESC,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [BUSINESS_COMBINATIONS_FAILURES]: [
    "OUT_INSTNAME",
    "OUT_CERT",
    "ACQ_INSTNAME",
    "ACQ_CERT",
    "SUR_INSTNAME",
    "SUR_CERT",
    SUR_CHANGECODE_DESC,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [INTERIM_MERGERS]: [
    "CERT",
    "FRM_INSTNAME",
    "FRM_CLASS",
    "FRM_REGAGENT",
    "INSTNAME",
    "CLASS",
    "REGAGENT",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [CONVERSIONS]: [
    CHANGECODE_DESC,
    "CERT",
    "FRM_INSTNAME",
    "FRM_CLASS",
    "FRM_CHARTAGENT",
    "FRM_REGAGENT",
    "INSTNAME",
    "CLASS",
    "CHARTAGENT",
    "REGAGENT",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [TITLE_CHANGES]: [
    "CERT",
    "CLASS",
    "FRM_INSTNAME",
    "INSTNAME",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [MAIN_OFFICE_RELOCATIONS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    "REGAGENT",
    FROM_ADDRESS,
    PHYSICAL_ADDRESS,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [LIQUIDATIONS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    "REGAGENT",
    "ACQ_BRANCHES",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [TRUST_POWERS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    "FRM_TRUST",
    "TRUST",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [BRANCH_OFFICE_RELOCATIONS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    FROM_OFFICE_ADDRESS,
    OFFICE_ADDRESS,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [PANDAS]: [
    "OUT_INSTNAME",
    "OUT_CERT",
    "OUT_CLASS",
    "OUT_REGAGENT",
    "ACQ_INSTNAME",
    "ACQ_CERT",
    "ACQ_CLASS",
    "ACQ_REGAGENT",
    "ACQ_BRANCHES",
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [OFFICE_OPENINGS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    OFFICE_ADDRESS,
    OFF_SERVTYPE_DESC,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
  [OFFICE_CLOSINGS]: [
    "INSTNAME",
    "CERT",
    "CLASS",
    OFFICE_ADDRESS,
    OFF_SERVTYPE_DESC,
    FORMATTED_DATE,
    VIEW_DETAILS,
  ],
};

export const oscrTableHeaderDictionary: { [index: string]: string[] } = {
  "Institutions": [
    NEW_INSTITUTIONS,
    BUSINESS_COMBINATIONS,
    BUSINESS_COMBINATIONS_FAILURES,
    INTERIM_MERGERS,
    CONVERSIONS,
    TITLE_CHANGES,
    MAIN_OFFICE_RELOCATIONS,
    LIQUIDATIONS,
    TRUST_POWERS,
    PANDAS,
  ],
  "Branch Offices": [
    BRANCH_OFFICE_RELOCATIONS,
    OFFICE_OPENINGS,
    OFFICE_CLOSINGS,
  ],
};

export const oscrDataTemplate = {
  count_CLASS_N: 0,
  count_CLASS_SM: 0,
  count_CLASS_NM: 0,
  count_CLASS_OI: 0,
  count_CLASS_SI: 0,
  count_CLASS_SB: 0,
  count_CLASS_SL: 0,
  count_CLASS_NC: 0,
  count_CLASS_NS: 0,
  count_CLASS_CU: 0,
  count: 0,
};

export const primaryHeaderColor = "#1A4480";
export const secondaryHeaderColor = "#4D73B1";
export const additionalHeaderColor = "#006767";
export const textHeaderColor = "#ffffff";
export const headerBreakColorDark = "#06295c";
export const headerBreakColorLight = "#c6d8ea";

export const oscrHeaders: TableHeader[][] = [
  [
    {
      title: "Bank Types",
      styles: { width: "25%" },
      colSpan: 1,
    },
    {
      title: "Commercial & Industrial Banks",
      styles: { backgroundColor: headerBreakColorDark, width: "25%" },
      colSpan: 4,
    },
    {
      title: "Savings Banks & Savings and Loans",
      styles: { width: "25%" },
      colSpan: 3,
    },
    {
      title: "Non-FDIC-Insured Commercial Banks, Thrifts & Credit Unions",
      styles: { backgroundColor: headerBreakColorDark, width: "25%" },
      colSpan: 3,
    },
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor },
      colSpan: 1,
    },
  ],
  [
    {
      title: "Bank Classes",
      styles: {},
      colSpan: 1,
    },
    {
      title: "N",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip: "National Banks, member of the Federal Reserve System (FRS)",
    },
    {
      title: "SM",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip:
        "State Chartered Banks, member of the Federal Reserve System (FRS)",
    },
    {
      title: "NM",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip:
        "State Chartered Banks, not member of the Federal Reserve System (FRS)",
    },
    {
      title: "OI",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip: "Insured Branches of Foreign Banks",
    },
    {
      title: "SI",
      styles: {},
      colSpan: 1,
      toolTip: "FDIC Supervised State Savings Banks",
    },
    {
      title: "SB",
      styles: {},
      colSpan: 1,
      toolTip: "Federal Savings Bank",
    },
    {
      title: "SL",
      styles: {},
      colSpan: 1,
      toolTip: "Federal & State Savings and Loans",
    },
    {
      title: "NC",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip: "Non-FDIC-Insured Commercial Banks",
    },
    {
      title: "NS",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip: "Non-FDIC-Insured Thrifts",
    },
    {
      title: "CU",
      styles: { backgroundColor: headerBreakColorLight },
      colSpan: 1,
      toolTip: "Non-FDIC-Insured Credit Unions",
    },
    {
      title: "Totals",
      styles: {},
      colSpan: 1,
    },
  ],
];

export const date = {
  defaultMin: "08/01/1999",
  financialMin: "01/01/1792",
  inactiveMin: "01/01/1970",
  startDate: "startDate",
  establishedStartRange: "establishedStartRange",
  startDateLabel: "Start Date",
  startDateId: "start-date",
  endDate: "endDate",
  endDateLabel: "End Date",
  endDateId: "end-date",
  establishedEndId: "established-end-date",
  dateFormat: "MM/dd/yyyy",
};

const viewDetailsHeader = {
  title: "View Details",
  styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
  colSpan: 1,
};

const effDateHeader = {
  title: "Effective Date",
  styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
  colSpan: 1,
  apiField: "EFFDATE",
};

const changeDescriptionHeader = {
  title: "Change Description",
  styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
  colSpan: 1,
  apiField: "CHANGECODE_DESC",
};

const certHeader = {
  title: "Cert",
  styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
  colSpan: 1,
  apiField: "CERT",
};

const classHeader = {
  title: "Class",
  styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
  colSpan: 1,
  apiField: "CLASS",
};

const apiFieldLookup: KeyStringValue = {
  "Institution Name": "INSTNAME",
  "Cert": "CERT",
  "Class": "CLASS",
  "Primary Regulator": "REGAGENT",
  "Charter": "CHARTAGENT",
  "Effective Date": "EFFDATE",
  "Action Taken": "CHANGECODE_DESC",
  "Trust Before": "FRM_TRUST",
  "Trust After": "TRUST",
  // if this key is used elsewhere without the OFF_ prefix, remove it from here to make it more reusable and append the prefix where it is needed
  "Service Type": "OFF_SERVTYPE_DESC",
  "Total Branches": "ACQ_BRANCHES",
  "Branches Acquired": "BRANCHES",
};

export const newInstitutions: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Primary Regulator",
    "Address",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    apiField: apiFieldLookup[title],
    colSpan: 1,
  })),
];

export const businessCombinations: TableHeader[][] = [
  [
    {
      title: "Outgoing",
      styles: {
        backgroundColor: additionalHeaderColor,
        color: textHeaderColor,
      },
      colSpan: 2,
    },
    {
      title: "Acquiring",
      styles: { backgroundColor: secondaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
    {
      title: "Surviving",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 6,
    },
  ],
  (() => {
    const headerValues = ["Institution Name", "Cert"];

    const outBusinessCombinations: TableHeader[] = headerValues.map(
      (header: string) => {
        return {
          title: header,
          styles: {
            backgroundColor: additionalHeaderColor,
            color: textHeaderColor,
          },
          colSpan: 1,
          apiField: `OUT_${apiFieldLookup[header]}`,
        };
      },
    );

    const acqBusinessCombinations: TableHeader[] = headerValues.map(
      (header: string) => {
        return {
          title: header,
          styles: {
            backgroundColor: secondaryHeaderColor,
            color: textHeaderColor,
          },
          colSpan: 1,
          apiField: `ACQ_${apiFieldLookup[header]}`,
        };
      },
    );

    const surBusinessCombinations: TableHeader[] = [
      ...headerValues,
      "Action Taken",
      "Effective Date",
    ].map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: primaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: `${header !== "Effective Date" && header !== "Action Taken" ? "SUR_" : ""
          }${apiFieldLookup[header]}`,
      };
    });

    return [
      ...outBusinessCombinations,
      ...acqBusinessCombinations,
      ...surBusinessCombinations,
      viewDetailsHeader,
    ];
  })(),
];

export const businessCombinationFailures: TableHeader[][] = [
  ...businessCombinations,
].map((headers: TableHeader[]) => {
  return headers.map((header: TableHeader) => {
    if (header.title === "Action Taken") {
      return {
        title: header.title,
        styles: {
          backgroundColor: primaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: "SUR_CHANGECODE_DESC",
      };
    } else {
      return header;
    }
  });
});

export const interimMergers: TableHeader[][] = [
  [
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 1,
    },
    {
      title: "Before Changes",
      styles: {
        backgroundColor: additionalHeaderColor,
        color: textHeaderColor,
      },
      colSpan: 3,
    },
    {
      title: "After Changes",
      styles: { backgroundColor: secondaryHeaderColor, color: textHeaderColor },
      colSpan: 3,
    },
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
  ],
  (() => {
    const headerValues = ["Institution Name", "Class", "Primary Regulator"];

    const beforeChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: additionalHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: `FRM_${apiFieldLookup[header]}`,
      };
    });

    const afterChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: secondaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: apiFieldLookup[header],
      };
    });

    return [
      certHeader,
      ...beforeChanges,
      ...afterChanges,
      effDateHeader,
      viewDetailsHeader,
    ];
  })(),
];
export const conversions: TableHeader[][] = [
  [
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
    {
      title: "Before Changes",
      styles: {
        backgroundColor: additionalHeaderColor,
        color: textHeaderColor,
      },
      colSpan: 4,
    },
    {
      title: "After Changes",
      styles: { backgroundColor: secondaryHeaderColor, color: textHeaderColor },
      colSpan: 4,
    },
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
  ],
  (() => {
    const headerValues = [
      "Institution Name",
      "Class",
      "Charter",
      "Primary Regulator",
    ];
    const beforeChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: additionalHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: `FRM_${apiFieldLookup[header]}`,
      };
    });
    const afterChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: secondaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: apiFieldLookup[header],
      };
    });

    return [
      changeDescriptionHeader,
      certHeader,
      ...beforeChanges,
      ...afterChanges,
      effDateHeader,
      viewDetailsHeader,
    ];
  })(),
];

export const titleChanges: TableHeader[][] = [
  [
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
    {
      title: "Before Changes",
      styles: {
        backgroundColor: additionalHeaderColor,
        color: textHeaderColor,
      },
      colSpan: 1,
    },
    {
      title: "After Changes",
      styles: { backgroundColor: secondaryHeaderColor, color: textHeaderColor },
      colSpan: 1,
    },
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
  ],
  (() => {
    const headerValues = ["Institution Name"];

    const beforeChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: additionalHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: `FRM_${apiFieldLookup[header]}`,
      };
    });

    const afterChanges: TableHeader[] = headerValues.map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: secondaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: apiFieldLookup[header],
      };
    });

    return [
      certHeader,
      classHeader,
      ...beforeChanges,
      ...afterChanges,
      effDateHeader,
      viewDetailsHeader,
    ];
  })(),
];

export const mainOfficeRelocations: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Primary Regulator",
    "Address Before",
    "Address After",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];

export const liquidations: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Primary Regulator",
    "Total Branches",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];
export const trustPowers: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Trust Before",
    "Trust After",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];

export const branchOfficeRelocation: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Branch Address Before",
    "Branch Address After",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];

export const purchaseAssumptionBranches: TableHeader[][] = [
  [
    {
      title: "Selling Institution",
      styles: {
        backgroundColor: additionalHeaderColor,
        color: textHeaderColor,
      },
      colSpan: 4,
    },
    {
      title: "Acquiring Institution",
      styles: { backgroundColor: secondaryHeaderColor, color: textHeaderColor },
      colSpan: 5,
    },
    {
      title: " ",
      styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
      colSpan: 2,
    },
  ],
  (() => {
    const headerValues = [
      "Institution Name",
      "Cert",
      "Class",
      "Primary Regulator",
    ];

    const sellingInstitutions: TableHeader[] = headerValues.map(
      (header: string) => {
        return {
          title: header,
          styles: {
            backgroundColor: additionalHeaderColor,
            color: textHeaderColor,
          },
          colSpan: 1,
          apiField: `OUT_${apiFieldLookup[header]}`,
        };
      },
    );

    const acquiringInstitutions: TableHeader[] = [
      ...headerValues,
      "Branches Acquired",
    ].map((header: string) => {
      return {
        title: header,
        styles: {
          backgroundColor: secondaryHeaderColor,
          color: textHeaderColor,
        },
        colSpan: 1,
        apiField: `ACQ_${apiFieldLookup[header]}`,
      };
    });

    return [
      ...sellingInstitutions,
      ...acquiringInstitutions,
      effDateHeader,
      viewDetailsHeader,
    ];
  })(),
];

export const officeOpeningsHeaders: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Branch Address",
    "Service Type",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];

export const officeClosingHeaders: TableHeader[][] = [
  [
    "Institution Name",
    "Cert",
    "Class",
    "Branch Address",
    "Service Type",
    "Effective Date",
    "View Details",
  ].map(title => ({
    title,
    styles: { backgroundColor: primaryHeaderColor, color: textHeaderColor },
    colSpan: 1,
    apiField: apiFieldLookup[title],
  })),
];

export const TRADE_NAMES: string[] = [
  "TE01N529.raw",
  "TE02N529.raw",
  "TE03N529.raw",
  "TE04N529.raw",
  "TE05N529.raw",
  "TE06N529.raw",
];

export const PRIOR_NAMES: string[] = [
  "PRIORNAME1.raw",
  "PRIORNAME2.raw",
  "PRIORNAME3.raw",
  "PRIORNAME4.raw",
  "PRIORNAME5.raw",
  "PRIORNAME6.raw",
  "PRIORNAME7.raw",
  "PRIORNAME8.raw",
  "PRIORNAME9.raw",
  "PRIORNAME10.raw",
];

export const WEBSITES: string[] = [
  "TE01N528",
  "TE02N528",
  "TE03N528",
  "TE04N528",
  "TE05N528",
  "TE06N528",
  "TE07N528",
  "TE08N528",
  "TE09N528",
  "TE10N528",
];

export const defaultStructureChangeLevelTwoSortFields: KeyStringValue = {
  "Business Combinations": "SUR_INSTNAME",
  "Business Combinations - Failures": "SUR_INSTNAME",
  "Branch Purchases & Assumptions by Institution": "ACQ_INSTNAME",
};

export function formatId(id: string) {
  return id
    .replace(/&/g, "and")
    .replace(/[^a-zA-Z ]/g, "")
    .replace(/ /g, "-")
    .toLowerCase();
}

export const dynamicSearchList = [
  {
    title: [
      {
        subHeading:
          "Useful for following Institutions that share similar characteristics including:",
        subTitle: [
          "Financial Size",
          "Banking Class or Regulator",
          "Physical Location",
          "Economic Specialties",
          "and more...",
        ],
      },
    ],
  },
  {
    title: [
      {
        subHeading: "Dynamically adjusts over time as institutions come and go",
        subTitle: [],
      },
    ],
  },
  {
    title: [
      {
        subHeading: "Gives a more holistic view of the industry",
        subTitle: [],
      },
    ],
  },
];

export const explicitSearchList = [
  "Useful for following specific Institutions",
  "Limited to only the Institutions listed",
  "Cannot grow (more institutions) over time",
  "Can shrink over time as Institutions cease to operate (failure/merger) or if a reporting period is selected before an Institution’s existence",
];

export const DisclaimersAndMethodologies = [
  {
    heading: "Index of Contents",
  },
];

export const ReleaseNotes = [
  {
    heading: "10/13/2026 – Release 64.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements", subTitle: ["New - Help – Glossary & Variable Search for Annual Data Summaries and Failures and Assistance", "Update Section 508 color change", "SOD Market Share reset button"],
      },
      {
        subHeading:
          "Improvements to Reports and Comparisons"
        , subTitle: ["Add MSA search in Financial Reporting"],
      },

      {
        subHeading:
          "Additional Data Visualizations"
        , subTitle: ["SOD Summary Table", "SOD Top 50 BHC"],
      },
      {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "09/01/2026 – Release 63.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements", subTitle: ["Update Section 508 color change", "Enlarge help icon", "Add sticky header to locations"],
      },
      {
        subHeading:
          "Improvements to Find Insured Banks"
        , subTitle: ["Flag to update bank status"],
      },
      {
        subHeading:
          "Improvements to Reports and Comparisons"
        , subTitle: ["Update Summary Table"],
      },
      {
        subHeading:
          "Additional Data Visualizations"
        , subTitle: ["SOD and Branch Office Deposits maps", "Bank Structure Changes mapping"],
      },
      {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "07/21/2026 – Release 62.0",
    title: [
      {
        subHeading:
          "Data.gov API Key Roll-out & Governance API", subTitle: ["Key Banner Announcements for the future requirement of API Keys for data access"],
      }, {
        subHeading:
          "Improvements to Location Selection for Annual Data Summaries", subTitle: ["Improvements in aggregated selections"],
      }, {
        subHeading:
          "Site-wide Improvements", subTitle: ["Update text and format changes across the Site"],
      },
      {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "06/09/2026 – Release 61.0",
    title: [
      {
        subHeading:
          "Improvements to Find Insured Banks", subTitle: ["Data Visualizations"],
      }, {
        subHeading:
          "Enhancements to Custom Reports", subTitle: ["Load and share custom reports"],
      }, {
        subHeading:
          "Site-wide Improvements", subTitle: ["Update text and format changes across the Site"],
      },
      {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "04/28/2026 – Release 60.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits", subTitle: ["Branch Office Deposits Data Visualizations"], additionalNotes: ["Table and Map View toggle", "State and county drill down"],
      }, {
        subHeading:
          "Improvements to Custom Reports", subTitle: ["Share and load custom reports"],
      }, {
        subHeading:
          "Site-wide Improvements", subTitle: ["Update text and format changes across the Site"],
      },
      {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "03/17/2026 – Release 59.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements", subTitle: ["Help Glossary Name changes", "Improvements in Data Preparation", "Improved Consistency between landing page and lower pages"],
      }, {
        subHeading:
          "Technical Package Upgrades", subTitle: [""],
      }, {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "02/04/2026 – Release 58.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements", subTitle: ["Landing Page Improvements", "Accessibility and Usability Improvements", "Update text and format changes across the Site", "Style updates for mobile"],
      }, {
        subHeading:
          "Technical Package Upgrades", subTitle: [""],
      }, {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "12/02/2025 – Release 57.0",
    title: [
      {
        subHeading:
          "Accessibility and Usability Improvements", subTitle: [""],
      }, {
        subHeading:
          "Technical Upgrades", subTitle: [""],
      }, {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "10/14/2025 – Release 56.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements", subTitle: ["Accessibility and Usability Improvements", "Update text and format changes across the Site", "Update Section 508 findings"],
      }, {
        subHeading:
          "Technical Package Upgrades", subTitle: [""],
      }, {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  }, {
    heading: "09/03/2025 – Release 55.0",
    title: [
      {
        subHeading:
          "Accessibility and Usability Improvements", subTitle: [""],
      }, {
        subHeading:
          "Technical Package Upgrades", subTitle: [""],
      }, {
        subHeading:
          "Bug Fixes", subTitle: [""],
      },
    ],
  },
  {
    heading: "07/22/2025 – Release 54.0",
    title: [
      {
        subHeading:
          "Site-wide Improvements",
        subTitle: [
          "Setup Data.gov API Management Service", "New - HELP – Create Glossary and Variable Definition – View by Topic", "New – Financial Reporting -Add MSA to Regulatory Search", "Remove several variables from API", "Bug Fixes",
        ],
      },
    ],
  }, {
    heading: "06/10/2025 – Release 53.0",
    title: [
      {
        subHeading:
          "Usability Enhancements",
        subTitle: [
          "Key Statistics display data according to the search criteria",
        ],
      },
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "New – SOD Help Library Topic that includes:",
        ],
        additionalNotes: ["SOD Overview of Content", "Listing of SOD Data Amendments and subscription for data releases", "SOD Metropolitan Statistical Areas (MSAs)"],

      },
      {
        subHeading:
          "Bug Fixes",
        subTitle: [""],
      },
    ],
  }, {
    heading: "4/29/2025 – Release 52.0",
    title: [
      {
        subHeading:
          "Modifications to Peer Group Comparisons",
        subTitle: [
          "Standard Peer Groups available without Login",
          "Duplicate Saved Names - Not  allowed",
        ],
      },
      {
        subHeading:
          "Additional Improvements to Bulk Data Download and API Endpoints",
        subTitle: [
          "Financials",
          "Institutions",
          "Locations",
          "Historical (Structure Changes)",
          "Failures",
          "SOD (Summary of Deposits)",
          "Summary (History Data Aggregations)",
        ],
      },
      {
        subHeading:
          "Minor Bug Fixes",
        subTitle: [""],
      },
    ],
  }, {
    heading: "03/18/2025 – Release 51.0",
    title: [
      {
        subHeading:
          "Modifications to Peer Group Comparisons - Customized Comparison",
        subTitle: [
          "Search Side Selection Manager Area enhanced with Reset Button",
          "Saved Peer Group Side Report Population enhanced for Standard Peer Groups",
        ],
      },
      {
        subHeading:
          "Site-wide Improvements",
        subTitle: [
          "Improvement to Institutions Details Page",
        ],
      },
    ],
  }, {
    heading: "02/04/2025 – Release 50.0",
    title: [
      {
        subHeading:
          "Improvements  to Peer Group Comparisons - Customized Comparison",
        subTitle: [
          "Additional enhancements to Search Side Report Population Area",
          "Additional enhancements to Search Side Selection Manager Area",
          "Additional enhancements to Pill and Peer Group Cards",
          "Additional enhancements to Saved Peer Group Side Report Population",
          "Update to Institutions Details Modal",
        ],
      },
    ],
  },
  {
    heading: "12/10/2024 - Release 49.0",
    title: [
      {
        subHeading:
          "Improvements to SOD - Custom Data Download",
        subTitle: [
          "Overwrite and Rename Saved Configurations",
        ],
      },
      {
        subHeading:
          "Improvements to Financial Reporting",
        subTitle: ["New - Financial Reporting Landing Page",
          "Update to Your Custom Content Page - Create/Edit Custom SOD Downloads Tab",
        ],
      },
      {
        subHeading: "Improvements to Bulk Download and API",
        subTitle: ["New - Bulk Download and API Landing Page", "API 101 - Information about the use of API's"],
        additionalNotes: ["Consolidation of information about Bulk Data and API's"],
      },
    ],
  },
  {
    heading: "10/29/2024 - Release 48.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Additional enhancements to Pro-Forma search by RSSDHCR - Bank without BHC in Partial Merger",
          "Additional enhancements to Custom Data Download - Rename the Preview, Delete, and Duplication",
        ],
      },
      {
        subHeading:
          "Improvements to BankFind Suite",
        subTitle: ["Update to Manage Your Custom Content Page - Custom SOD Downloads Tab"],
      },
      {
        subHeading: "Improvements to Help",
        subTitle: ["Tutorials added for Pro-Forma and Custom Data Download"],
      },
    ],
  },
  {
    heading: "09/17/2024 - Release 47.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Additional enhancements to Pro-Forma search by RSSDHCR - Institution Acquires BHC in Complete Merger",
          "Additional enhancements to Custom Data Download - Manually edit and lookup variables",
          "Removal of SOD Beta Tag",
        ],
      },
    ],
  }, {
    heading: "08/06/2024 - Release 46.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Additional enhancements to Pro-Forma search by RSSDHCR - State/County/City/Zip and MSA",
          "Introduction to Custom Data Download – Direct Select",
        ],
      },
    ],
  }, {
    heading: "06/25/2024 - Release 45.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Enhancements to Pro-Forma capabilities to search by RSSDHCR - State/County/City/Zip and MSA and Level II Partial Mergers",
        ],
      },
    ],
  }, {
    heading: "05/14/2024 - Release 44.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Introduction to Pro-Forma capabilities to search by State/County/City/Zip, MSA, and Zip Only",
        ],
      },
    ],
  }, {
    heading: "04/02/2024 - Release 43.0",
    title: [
      {
        subHeading:
          "BankFind Suite",
        subTitle: [
          "Configurable Banner for system wide notifications",
        ],
      },
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Remaining Growth Rate capabilities to search by FDIC Cert # by MSAs, RSSDHCR, and Bank Holding Company",
        ],
      },
    ],
  }, {
    heading: "02/21/2024 - Release 42.0",
    title: [
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Remaining Deposit Market Share Reports including BHC", "Introduction to Growth Rate with capabilities to search by Bank Name and FDIC Cert # by State and County",
        ],
      },
    ],
  }, {
    heading: "12/12/2023 - Release 41.0",
    title: [
      {
        subHeading:
          "Improvements to Historical Bank Data",
        subTitle: [
          "Total Offices included in Default view",
        ],
      },
      {
        subHeading:
          "Improvements to Summary of Deposits",
        subTitle: [
          "Introduction to Deposit Market Share Reports including Find Office Locations By",
        ],
        additionalNotes: ["State/County/City/Zip", "County Summaries by State", "MSA"],
      },
    ],
  },
  {
    heading: "11/13/2023 - Release 40.1",
    title: [
      {
        subHeading:
          "Bug Fixes to Peer Group Comparisons",
        subTitle: [
          "Data fix and custom report view",
        ],
      },
    ],
  },
  {
    heading: "10/31/2023 - Release 40.0",
    title: [
      {
        subHeading: "Improvements to Historical Bank Data",
        subTitle: ["Total Offices included in Default view"],
      },
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          "Additions to Market Share Reports – Market Presence Search Panel:",
        ],
        additionalNotes: [
          "FDIC Cert # - Nationally by State & County, Single State by County",
          "BHC – Bank Name",
          "RSSDHCR – MSAs, Single State by County",
        ],
      },
    ],
  },
  {
    heading: "9/19/2023 - Release 39.0",
    title: [
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          "MSA added to Summary Tables",
          "Introduction of Market Share Reports – Market Presence Search Panel, search by FDIC Cert # by state and MSAs",
        ],
      },
    ],
  },
  {
    heading: "8/22/2023 - Release 38.1",
    title: [
      {
        subHeading:
          "Improvements to Financial Reporting, Peer Group Comparisons, and API",
        subTitle: [
          "Default Raw Download format",
          "Updates to Uninsured/Insured Deposit Variables and Calculations; footnotes",
        ],
      },
    ],
  },
  {
    heading: "8/8/2023 - Release 38.0",
    title: [
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          " Additions to Summary Tables including National – Time Series, State – Charter Class Level 2, and State – By County",
        ],
      },
    ],
  },
  {
    heading: "6/27/2023 - Release 37.0",
    title: [
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          "Introduction to Summary Tables Search panel, including National – by Asset Size, National – by State, Top 50 Bank Holding Companies, and State Charter Class",
        ],
      },
    ],
  },
  {
    heading: "5/09/2023 - Release 36.0",
    title: [
      {
        subHeading: "BankFind Suite",
        subTitle: [
          "Updated order of icons on Landing Page, including additional link to the Help Library",
        ],
      },
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          "Introduction to Summary Tables Search panel, including National – by Charter Class Report Type",
        ],
      },
    ],
  },
  {
    heading: "4/04/2023 - Release 35.0",
    title: [
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          "Bank Holding Companies Location Search",
          "Location Only Search",
        ],
      },
    ],
  },
  {
    heading: "2/14/2023 - Release 34.0",
    title: [
      {
        subHeading: "Improvements to Summary of Deposits",
        subTitle: [
          " Additional search capabilities, including Locations Search and Bank Holding Company Search",
          "Concentration of Deposits Map",
        ],
      },
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: ["Addition of Interstate Offices to Demographics Report"],
      },
      {
        subHeading: "Changes to Name and Location",
        subTitle: ["Removal of Trade URLs"],
      },
      {
        subHeading: "Improvements to Help",
        subTitle: ["Addition of BankFind Tutorials on Help Page"],
      },
    ],
  },
  {
    heading: "12/21/2022 - Release 33.0",
    title: [
      {
        subHeading: "Summary of Deposits",
        subTitle: ["Introduction of Branch Office Deposits – search by Cert"],
      },
    ],
  },
  {
    heading: "12/7/2022 - Release 32.2",
    title: [
      {
        subHeading: "BankFind Suite",
        subTitle: [
          "Temporary warning message added to notify users of application performance during root cause analysis.",
        ],
      },
      {
        subHeading: "Changes to Financial Reporting",
        subTitle: [
          "Removal of FR Raw Data Download",
          "Limit of 500 records for financial requests of 250 variables or more",
        ],
      },
    ],
  },
  {
    heading: "11/22/2022 - Release 32.1",
    title: [
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: [
          "Fix to display missing banks from the state of Oregon",
          "Ability to download search result data",
        ],
      },
      {
        subHeading: "Improvements to Peer Group Comparisons",
        subTitle: ["Fix to enable Customized Report from Peer Group Page"],
      },
    ],
  },
  {
    heading: "11/08/2022 - Release 32.0",
    title: [
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: [
          "Addition of Demographic Information search functionality, look up variables on custom reports",
        ],
      },
      {
        subHeading: "Improvements to Peer Group Comparisons",
        subTitle: ["Customized Comparisons – Search Panel and Search Page"],
      },
      {
        subHeading: "Improvements to Help",
        subTitle: [
          "Added functionality to View Variable by Name",
          "Addition of Disclaimers and Methodologies for FR and PGC",
        ],
      },
    ],
  },
  {
    heading: "09/27/2022 - Release 31.0",
    title: [
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: ["Ability to select saved custom report definitions"],
      },
      {
        subHeading: "Improvements to Peer Group Comparisons",
        subTitle: [
          "Customized Comparisons – Search Panel and Search Page, Multiple Institution selection, Creating a Peer Group from Search Criteria",
          "Edit saved custom Peer Groups",
        ],
      },
    ],
  },
  {
    heading: "08/22/2022 - Release 30.0",
    title: [
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: [
          " Addition of Assets and Liabilities: Loss-Share Agreements, Bank Assets Sold and Securitized, Past Due and Nonaccrual Assets, Off-Balance Sheet and Fiduciary and Related Services",
        ],
      },
      {
        subHeading: "Improvements to Peer Group Comparisons",
        subTitle: [
          "Add Login.gov sign in to Peer Group Comparison Landing Page",
          "Addition of Create a Customized Report, Define Custom Peer Groups, Define Custom Peer Groups – Explicit Cert List, View, Save and Delete Custom Peer Group",
        ],
      },
      {
        subHeading: "Implementation of Login.gov PROD",
        subTitle: [
          "Login.gov and Logout functionality",
          " Interagency Agreement IAA with Login Page",
        ],
      },
    ],
  },
  {
    heading: "06/22/2022 - Release 29.0",
    title: [
      {
        subHeading: "Improvements to Financial Reporting",
        subTitle: ["Addition of Nonaccrual Asset and Past Due"],
      },
      {
        subHeading: "Improvements to Peer Group Comparisons",
        subTitle: ["Landing Page with initial functionality"],
      },
      {
        subHeading: "Improvements to Help",
        subTitle: ["Introduction of Glossary and Variable Definition"],
      },
    ],
  },
  {
    heading: "05/10/2022 - Release 28.0",
    title: [
      {
        subHeading: "Improvements to Peer Group Comparison",
        subTitle: [
          "Search Panel and Search Page",
          "Addition of Single Institution (Cert #), Multiple Institutions, Reporting Period Pill",
        ],
      },
    ],
  },
  {
    heading: "04/06/2022 - Release 27.1",
    title: [
      {
        subHeading: "Improvements to Peer Group Comparison",
        subTitle: [
          "Introductory language added to Peer Group Comparison pages",
        ],
      },
    ],
  },
  {
    heading: "03/29/2022 - Release 27.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "Addition of Regulatory Bank Holding Companies search capability and Inactive Date Range",
        ],
      },
      {
        subHeading: "Improvements to Peer Group Comparison Enhancements",
        subTitle: [
          "Additional functionality for standard comparison report generation",
          "Introduction of Customized Comparison Reports",
        ],
      },
      {
        subHeading: "Improvements to Historical Bank Data Section",
        subTitle: [
          "Add 2021 Historic Bank Data, including fourth quarter quarterly data",
        ],
      },
    ],
  },
  {
    heading: "02/15/2022 – Release 26.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section and Peer Group Comparison Introduction",
        subTitle: [
          "Add percentile toggle to transition between YTD and Percentage values for Assets and Liabilities",
          "Add capability to create custom financial reports",
          "Add Peer Group Comparison base page and standard comparisons",
        ],
      },
    ],
  },
  {
    heading: "12/14/2021 – Release 25.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "New reports available including Interest and Expense, Net Charge Offs, Income and Expense, Performance and Condition Ratios, Assets and Liabilities",
          "Add capability to search based on Asset Concentration, Common Search, Top 100 Banks and Thrifts by Assets, and Agricultural Banks",
          "The percentile toggle is available to transition between YTD and Percentage values (percentage values for Assets and Liabilities will be available in a future release)",
        ],
      },
    ],
  },
  {
    heading: "11/2/2021 – Release 24.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "Add capability to search based on charter class, chartering agency, federal regulator, and FDIC region",
          "Add formatted data download",
        ],
      },
      {
        subHeading:
          "Improvements to Find Institutions by Name and Location; Find Events and Changes",
        subTitle: ["Add Address Line 2 display"],
      },
    ],
  },
  {
    heading: "09/14/2021 – Release 23.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "Add additional groupings 2-4 within the data reports/tables, including sub-groupings that provide additional data metrics such as interest income and interest expense",
          "Add toggle between dollar and percent values for groupings 0-4",
          "Percent values for the remaining groupings (5-21) are being developed and will be available in the next release.",
        ],
      },
      {
        subHeading:
          "Improvements to Application Programming Interface and Historical Bank Data section",
        subTitle: ["Add 2020 Historical Bank Statistics data"],
      },
      {
        subHeading: "Site-wide improvements",
        subTitle: [
          "Add “Help” icon on all pages to direct users to the help page",
          "Correct Section 508 Findings",
        ],
      },
    ],
  },
  {
    heading: "08/11/2021 – Release 22.1",
    title: [
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Correct the ‘0’s appearing in Events and Changes, Branch Office’s section of the page",
          "Update internet browser tab names to reflect the page name",
        ],
      },
    ],
  },
  {
    heading: "08/03/2021 – Release 22.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "Add additional groupings 2-4 within the data reports/tables, including toggle between dollar and percent values",
          "Additional groupings may allow the user to expand into sub-groupings that provide additional data metrics such as interest and expense",
        ],
      },
      {
        subHeading: " Improvements to Historical Bank Data section",
        subTitle: ["Add NETIMEN variable"],
      },
      {
        subHeading: " Improvements to Bank Failures & Assistance Data section",
        subTitle: [
          " Add ability to sort by any column in all three of the reporting types",
        ],
      },
      {
        subHeading: " Improvements to Find Events & Changes section",
        subTitle: [" Update the Offices table to read “Branch Offices”"],
      },
      {
        subHeading: "Site-wide improvements",
        subTitle: [
          " Update various components (such as color, font, size) for consistency across the Suite",
          "Update any blank values to display as “0”",
        ],
      },
    ],
  },
  {
    heading: "06/22/2021 – Release 21.0",
    title: [
      {
        subHeading:
          "Improvements to Run Financial Reports by Institution section",
        subTitle: [
          "Includes the Comparison tool to compare data over various time periods",
          "Enhancements to the results table display to enable viewing more data and improved navigation",
          "Add ability to search by Name and Cert",
          "Add ability to search by City, State, and Zip",
        ],
      },
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: ["Add ability to sort results by Name or Cert"],
      },
      {
        subHeading: "Site-wide improvements",
        subTitle: [
          "Add ability to download large (>10,000) records through download icon within each section",
        ],
      },
    ],
  },
  {
    heading: "05/17/2021 - Release 20.1",
    title: [{ subHeading: "Minor bug fixes", subTitle: [] }],
  },
  {
    heading: "05/11/2021 - Release 20.0",
    title: [
      {
        subHeading:
          "Beta launch of the Run Financial Reports by Institution section",
        subTitle: [
          "Includes the Income and Expense Report Type",
          "Includes all Quarterly & Year-To-Date dollar values for Income and Expense Report",
          "Search for and display institutions using financial criteria",
          "Selectable quarterly reporting period as search criteria",
        ],
      },

      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Allow user to search for all institutions",
          "Spell out Primary Regulator (no acronyms)",
          "Bank Class code refinements for NC, NS, and SA, plus definitions update",
        ],
      },
      {
        subHeading:
          "Improvements to Find Bank Failures & Assistance Data section",
        subTitle: [
          "Update Bank Failures & Assistance Data functionality and graphics to match rest of BankFind Suite",
        ],
      },
      {
        subHeading: "Improvements to BankFind Suite Landing Page",
        subTitle: [
          "Create access to Run Financial Reports & Institution section",
          "Implement style and design enhancements based on revised FDIC branding guidelines",
        ],
      },
    ],
  },
  {
    heading: "04/02/2021 - Release 19.1",
    title: [{ subHeading: "Technical package upgrade", subTitle: [] }],
  },
  {
    heading: "03/30/2021 - Release 19.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Add Status (Active/Inactive) search criteria",
          "Remove default “Sort by Active Status”",
        ],
      },

      {
        subHeading: "Site-wide Improvements",
        subTitle: [
          "Update “Contact the FDIC Link” to provide better page source tracking",
        ],
      },
    ],
  },
  {
    heading: "02/16/2021 - Release 18.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Display refinements for ordering of historic events that occur on the same day",
          "Update plain language for certain historic event codes",
          "Include number of Total Events on Institution Details History Tab",
          "Update out-of-date data transformation rules for labeling SB/SI bank classes",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: ["Added auto-suggest for city search"],
      },
      {
        subHeading: "Improvements to Find Annual Historic Bank Data section",
        subTitle: [
          "Update Historic Bank Data functionality and graphics to match rest of BankFind Suite",
          "Enhance interface to dynamically update when new data is available",
        ],
      },
      {
        subHeading: "Improvements to API Documentation",
        subTitle: [
          "Update API documentation text for Financials",
          "Update API to include the minority status of institutions",
          "Update API Definition Files for Longitude and Latitude coordinates of minority institutions",
        ],
      },
      {
        subHeading: "Site-wide Improvements",
        subTitle: [
          "Update “Contact the FDIC” link throughout BankFind Suite to improve consistency",
        ],
      },
      {
        subHeading: "Improvements based on Section 508 review",
        subTitle: [
          "Find Events & Changes - Improve keyboard navigation when selecting dates with calendar component",
          "Find Events & Changes - Improve keyboard navigation when selected/deselected form radio buttons",
          'Improve alt text for a better description of “FDIC-Insured" when using green check mark as institution status indicator',
        ],
      },
    ],
  },
  {
    heading: "01/12/2021 - Release 17.1",
    title: [
      {
        subHeading: "Minor bug fixes",
        subTitle: [],
      },
    ],
  },
  {
    heading: "12/15/2020 - Release 17.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Add “Key Statistics” to Name & Location search page",
          "Add ability to download data on Search and Institution Details pages",
          "Add auto-suggest to City search",
          'Add "City" to the Locations Table and "View Matching/All Locations" modal',
          "Carry-over search criteria “pills” from Search page to Institution Details page to target specific branch locations",
          "Include branch locations results when searching with State or Zip criteria",
          "Add pagination capability to branch location modals",
          "Add mapping capability to branch location modals",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Add pagination capability to branch location modals",
          "Add ability to search by City",
        ],
      },
      {
        subHeading: "Site-wide Improvements",
        subTitle: ["Updated “Contact the FDIC Link” throughout BankFind Suite"],
      },
    ],
  },
  {
    heading: "10/27/2020 - Release 16.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Include branch locations results when searching with State and Zip criteria",
          "Improve display of a prior institution name",
          "Add auto-suggest to Name search",
          "Add ability to search by City",
          "Add Institution Profile tab to Institution Details pages",
          "Added History tab display to Institution Details pages",
          "Include modal display of individual events similar to Events & Changes",
          "Include link to failure for failed bank",
          "Revise logic on certain change codes to correctly display content pertinent to insurance coverage changes",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Remove “Date Acquired” from branch office liquidations display",
          'Adjust content labeling language to display "Main Office"',
          "Adjusted logic for Business Combinations - Failures to also indicate the update action taken on the event.",
        ],
      },
    ],
  },
  {
    heading: "9/15/2020 - Release 15.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "BETA status lifted",
          "Institution Card design refinements",
          "Add Trade Name and URL Data display to cards on Search results",
          "Add search criteria “pills” to results display",
          "Add Institution Details display of institution status and logic",
          "Add Branch/Locations Table to Institution Details pages",
          "Implement pagination for Locations table to return all results without limits",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Provide a way for a user to return to their workflow on Events & Changes after clicking “View Institution Details” from an event detail modal",
        ],
      },
      {
        subHeading: "Improvements to Find Annual Historic Bank Data section",
        subTitle: ["Update Start/End Date for 2019"],
      },
    ],
  },
  {
    heading: "8/4/2020 - Release 14.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Implement Institution Details pages with preliminary content",
          "Add preliminary Branch/Locations Table to Institution Details pages. First iteration limited to 200 locations returned without pagination",
          "Add Trade Name and URL Data to Institution Details pages",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Implement data download",
          "Refine search logic to separate Main Office (Institutions) events from Branch Office searches",
          "Implement display of involved branch offices for Purchase and Assumptions of Branches & Liquidations event details",
          "Implement display of involved branch offices for Business Combinations and Failures event details",
        ],
      },
      {
        subHeading: "Improvements to Find Bank Failures and Assistance section",
        subTitle: ["Refine content display", "Improvements to API"],
      },
      {
        subHeading: "Site-wide Improvements",
        subTitle: [
          "Incorporate Navigation Breadcrumbs",
          "Adjust page caching for better content display",
          "Content refinement of page titles and intros",
        ],
      },
    ],
  },
  {
    heading: "06/23/2020 - Release 13.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Refine Name Search to accommodate special characters",
          "Adjust logic for State/Territories to be in alphanumeric order",
        ],
      },
      {
        subHeading: "Site-wide Improvements",
        subTitle: [
          "Incorporate the new FDIC Header/Footer",
          "Implement the BankFind Suite Landing Page",
          "Implement “BankFind Suite Home” button on all pages for quick access to Landing Page",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Implement Hide/Show Search Panel when viewing Transaction Results Table",
          "Implement search criteria “Pills” to help define and adjust results content",
          "Implement logic and UI for new event type “Business Combination - Failures”",
          "Adjust logic and groupings to accommodate new change codes",
          "Implement refinements based on Section 508 review findings",
        ],
      },
    ],
  },
  {
    heading: "05/12/2020 - Release 12.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: ["Implement Pagination"],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Add ability to search by Name/Cert",
          "Add ability to search by State",
          "Improve Search Panel behaviors including Accordion Feature and Hide/Show",
          "Improve Summary Table layout",
          "Reorganize Summary Table content for clarity",
          "Add event-type specific content table to display lists of related events",
          "Implement Pagination",
          "Improve sorting and introduce a default sort order",
          "Add individual event transaction detail modals",
        ],
      },
    ],
  },
  {
    heading: "03/31/2020 - Release 11.0",
    title: [
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Implement individual Transaction Results Tables and integrate navigation with Summary Table page while preserving search parameters",
        ],
      },
    ],
  },
  {
    heading: "02/18/2020 - Release 10.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: [
          "Add Name Search capability",
          "Integrate Name and Cert selectors under a single area on the search panel",
          "Enhance Results Card to include: primary website, primary regulator, “Contact the FDIC” link, and improve styling",
        ],
      },
      {
        subHeading: "Improvements to Find Events & Changes section",
        subTitle: [
          "Adjust Summary Table content and display to create an Offices section",
          "Improve UI design for the Summary Table",
        ],
      },
    ],
  },
  {
    heading: "12/19/2019 - Release 9.0",
    title: [
      {
        subHeading: "Improvements to Find Annual Historic Bank Data section",
        subTitle: [
          "Update logic for results filtering",
          "Refine content displayed",
          "Add links to FDIC’s new feedback system",
        ],
      },
    ],
  },
  {
    heading: "11/14/2019 - Release 8.0",
    title: [
      {
        subHeading:
          "Improvements to Find Institutions by Name & Location section",
        subTitle: ["Implement UI Design enhancements"],
      },
      {
        subHeading: "Initial launch of Find Events & Changes section",
        subTitle: [
          "Implement initial Search Panel with ability to search for events by: Start/End Date, Event Type, and by “Process” or “Effective” Dates",
          "Display search results in a Summary Table",
        ],
      },
      {
        subHeading: "Site-wide Improvements",
        subTitle: ["Create links to FDIC’s new feedback system"],
      },
    ],
  },
];
